import React, { Component } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { settings } from "./settingsnew";
import { createGlobalStyle } from "styled-components";
import AOS from "aos";
AOS.init();

const GlobalStyles = createGlobalStyle`
    body.hide{
          overflow-y: hidden; /* Hide vertical scrollbar */
          overflow-x: hidden; /* Hide horizontal scrollbar */
        }
`;

class CustomSlide extends Component {
  render() {
    const { index, ...props } = this.props;
    return <div {...props}></div>;
  }
}

const Blog = function () {
  /* lightbox1 */
  const [lighbx, setlighbx] = React.useState(false);
  const handleBtnClick = (): void => {
    setlighbx(!lighbx);
    var x = document.getElementsByTagName("BODY")[0];
    x.style.overflow = "hidden";
  };
  const handleBtnClickclose = (): void => {
    setlighbx(!lighbx);
    var x = document.getElementsByTagName("BODY")[0];
    x.style.overflow = "auto";
  };

  const [lighbx1, setlighbx1] = React.useState(false);
  const handleBtnClick1 = (): void => {
    setlighbx1(!lighbx1);
    var x = document.getElementsByTagName("BODY")[0];
    x.style.overflow = "hidden";
  };
  const handleBtnClickclose1 = (): void => {
    setlighbx1(!lighbx1);
    var x = document.getElementsByTagName("BODY")[0];
    x.style.overflow = "auto";
  };

  const [lighbx2, setlighbx2] = React.useState(false);
  const handleBtnClick2 = (): void => {
    setlighbx2(!lighbx2);
    var x = document.getElementsByTagName("BODY")[0];
    x.style.overflow = "hidden";
  };
  const handleBtnClickclose2 = (): void => {
    setlighbx2(!lighbx2);
    var x = document.getElementsByTagName("BODY")[0];
    x.style.overflow = "auto";
  };

  return (
    <div className="container">
      <GlobalStyles />
      <div className="spacer-single"></div>
      <div className="row">
        <div className="col-md-12 text-center">
          <h2>Recent Blog</h2>
          <div className="space-border"></div>
        </div>
      </div>
      <div className="row" data-aos="fade-up" data-aos-once="true">
        <Slider {...settings}>
          <CustomSlide className="itm" index={1}>
            <div className="bloglist item">
              <div className="post-content">
                <div className="post-image">
                  <div className="de_modal" onClick={handleBtnClick}>
                    <img
                      alt="blogimg"
                      src="./img/blog/1.jpg"
                      className="grayscale"
                    />
                  </div>
                </div>
                <div className="post-text">
                  <h4 className="de_modal" onClick={handleBtnClick}>
                    How to Make Better User Interface
                  </h4>

                  <p>
                    Understanding your users' goals, skills, preferences, and
                    tendencies is essential to every aspect of interface design.
                    When designing your interface...
                  </p>
                </div>
              </div>
            </div>
          </CustomSlide>

          <CustomSlide className="itm" index={2}>
            <div className="bloglist item">
              <div className="post-content">
                <div className="post-image">
                  <div className="de_modal" onClick={handleBtnClick1}>
                    <img
                      alt="blogimg"
                      src="./img/blog/2.jpg"
                      className="grayscale"
                    />
                  </div>
                </div>
                <div className="post-text">
                  <h4 className="de_modal" onClick={handleBtnClick1}>
                    10 Web Design Tips From Experts
                  </h4>
                  <p>
                    It's not good for a web designer to run out of ideas. It can
                    be caused by a variety of factors, including overworking and
                    repetitive work. You need...
                  </p>
                </div>
              </div>
            </div>
          </CustomSlide>

          <CustomSlide className="itm" index={3}>
            <div className="bloglist item">
              <div className="post-content">
                <div className="post-image">
                  <div className="de_modal" onClick={handleBtnClick2}>
                    <img
                      alt="blogimg"
                      src="./img/blog/3.jpg"
                      className="grayscale"
                    />
                  </div>
                </div>
                <div className="post-text">
                  <h4 className="de_modal" onClick={handleBtnClick2}>
                    The Importance of Web Design
                  </h4>
                  <p>
                    One of your brand's most important online assets is your
                    website, so it's critical that you design it well.
                    Additionally, in order to convert...
                  </p>
                </div>
              </div>
            </div>
          </CustomSlide>

          <CustomSlide className="itm" index={4}>
            <div className="bloglist item">
              <div className="post-content">
                <div className="post-image">
                  <div className="de_modal" onClick={handleBtnClick}>
                    <img
                      alt="blogimg"
                      src="./img/blog/4.jpg"
                      className="grayscale"
                    />
                  </div>
                </div>
              </div>
            </div>
          </CustomSlide>
        </Slider>
      </div>

      {/* lightbox */}
      {lighbx && (
        <div className="LightboxGal">
          <div className="closeGal">
            <button
              className="button-close"
              onClick={handleBtnClickclose}
            ></button>
          </div>
          <div className="v-center w-100">
            <div className="mainLightbox container">
              <div className="row">
                <div className="col-md-8 offset-md-2">
                  <div className="blog-read">
                    <img
                      alt="blogimg"
                      src="./img/blog/big.jpg"
                      className="img-fullwidth rounded"
                    />

                    <div className="post-info">
                      <span className="post-date">February 14, 2023</span>
                      <span className="post-like"></span>
                      <span className="post-comment"></span>
                    </div>

                    <h2>How to Make Better User Interface</h2>

                    <div className="post-text">
                      <p>
                        Understanding your users' goals, skills, preferences,
                        and tendencies is essential to every aspect of interface
                        design. When designing your interface, keep the
                        following things in mind once you know who your user is:
                      </p>
                      <ul>
                        <li>
                          Maintain a simple user interface. The best user
                          interfaces are almost unnoticeable. On labels and in
                          messaging, they avoid unnecessary elements and use
                          language that is understandable.
                        </li>
                        <li>
                          Utilize common UI elements and ensure consistency.
                          Users are able to complete tasks more quickly and feel
                          more at ease when your user interface makes use of
                          standard components. To aid in efficiency, it is also
                          essential to establish language, layout, and design
                          patterns throughout the website. A user should be able
                          to apply what they have learned in one area to other
                          areas of the website.
                        </li>
                        <li>
                          Layout your pages with purpose. Structure the page
                          based on importance and think about the spatial
                          relationships between the items on the page. The most
                          important parts of the information can be more easily
                          scanned and read with careful placement of items.
                        </li>
                        <li>
                          Make smart use of color and texture. Utilizing color,
                          light, contrast, and texture to your advantage, you
                          can direct attention toward or away from items.
                        </li>
                        <li>
                          Utilize typography to establish order and clarity.
                          Give careful thought to how you use typeface. Text in
                          a variety of sizes, fonts, and arrangements to improve
                          scanability, legibility, and readability.
                        </li>
                        <li>
                          Make sure that the system tells you what's going on.
                          Always let your users know about errors, changes in
                          state, actions, or location. Your user's frustration
                          can be reduced by communicating status and, if
                          necessary, the next steps through a variety of UI
                          elements.
                        </li>
                        <li>
                          Consider the defaults. You can create defaults that
                          ease the user's burden by carefully considering and
                          anticipating the goals visitors bring to your site.
                          This is especially important when designing forms,
                          where you might be able to choose which fields to fill
                          out or leave blank.
                        </li>
                      </ul>
                    </div>
                  </div>

                  {/* <div id="blog-comment">
                    <h4>Comments</h4>

                    <div className="spacer-half"></div>

                    <ol>
                      <li>
                        <div className="avatar">
                          <img src="./img/blog/avatar-1.jpg" alt="blogimg" />
                        </div>
                        <div className="comment-info">
                          <span className="c_name">Jovan Eadie</span>
                          <span className="c_date id-color">
                            15 January 2020
                          </span>
                          <span className="c_reply">
                            <span>Reply</span>
                          </span>
                          <div className="clearfix"></div>
                        </div>

                        <div className="comment">
                          Sed ut perspiciatis unde omnis iste natus error sit
                          voluptatem accusantium doloremque laudantium, totam
                          rem aperiam, eaque ipsa quae ab illo inventore
                          veritatis et quasi architecto beatae vitae dicta sunt
                          explicabo.
                        </div>
                      </li>

                      <li>
                        <div className="avatar">
                          <img src="./img/blog/avatar-2.jpg" alt="blogimg" />
                        </div>
                        <div className="comment-info">
                          <span className="c_name">Ariana Haylock</span>
                          <span className="c_date id-color">
                            15 January 2020
                          </span>
                          <span className="c_reply">
                            <span>Reply</span>
                          </span>
                          <div className="clearfix"></div>
                        </div>

                        <div className="comment">
                          Sed ut perspiciatis unde omnis iste natus error sit
                          voluptatem accusantium doloremque laudantium, totam
                          rem aperiam, eaque ipsa quae ab illo inventore
                          veritatis et quasi architecto beatae vitae dicta sunt
                          explicabo.
                        </div>
                      </li>

                      <li>
                        <div className="avatar">
                          <img src="./img/blog/avatar-3.jpg" alt="blogimg" />
                        </div>
                        <div className="comment-info">
                          <span className="c_name">Reginald Safi</span>
                          <span className="c_date id-color">
                            15 January 2020
                          </span>
                          <span className="c_reply">
                            <span>Reply</span>
                          </span>
                          <div className="clearfix"></div>
                        </div>

                        <div className="comment">
                          Sed ut perspiciatis unde omnis iste natus error sit
                          voluptatem accusantium doloremque laudantium, totam
                          rem aperiam, eaque ipsa quae ab illo inventore
                          veritatis et quasi architecto beatae vitae dicta sunt
                          explicabo.
                        </div>
                      </li>
                    </ol>

                    <div className="spacer-single"></div>

                    <div id="comment-form-wrapper">
                      <h4>Leave a Comment</h4>
                      <div className="comment_form_holder">
                        <form
                          id="contact_form"
                          name="form1"
                          className="form-border"
                          method="post"
                          action="#"
                        >
                          <label>Name</label>
                          <input
                            type="text"
                            name="name"
                            id="name"
                            className="form-control"
                          />
                          <label>
                            Email <span className="req">*</span>
                          </label>
                          <input
                            type="text"
                            name="email"
                            id="email"
                            className="form-control"
                          />
                          <label>
                            Message <span className="req">*</span>
                          </label>
                          <textarea
                            cols="10"
                            rows="10"
                            name="message"
                            id="message"
                            className="form-control"
                          ></textarea>
                          <p id="btnsubmit">
                            <input
                              type="submit"
                              id="send"
                              value="Send"
                              className="btn btn-main"
                            />
                          </p>
                        </form>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* lightbox */}
      {lighbx1 && (
        <div className="LightboxGal">
          <div className="closeGal">
            <button
              className="button-close"
              onClick={handleBtnClickclose1}
            ></button>
          </div>
          <div className="v-center w-100">
            <div className="mainLightbox container">
              <div className="row">
                <div className="col-md-8 offset-md-2">
                  <div className="blog-read">
                    <img
                      alt="blogimg"
                      src="./img/blog/big2.jpg"
                      className="img-fullwidth rounded"
                    />

                    <div className="post-info">
                      <span className="post-date">February 15, 2023</span>
                      <span className="post-like"></span>
                      <span className="post-comment"></span>
                    </div>

                    <h2>10 Web Design Tips From Experts</h2>

                    <div className="post-text">
                      <p>
                        It's not good for a web designer to run out of ideas.
                        There are numerous causes, including overwork,
                        repetitive work, and more. You need new methods to come
                        up with fresh concepts. Find out where and how to
                        acquire fresh concepts for web design. <br />
                        If you're feeling unmotivated, uninspired, or just plain
                        stuck, the following steps can help you rekindle your
                        enthusiasm for web design:
                      </p>

                      <h6>Site purpose</h6>
                      <p>
                        A website's purpose, like a mission statement, explains
                        the primary reason it exists in the world. Whether it's
                        for community organizing, advocacy, education, or
                        providing services, Design and content choices will
                        ultimately be influenced by the site's primary purpose.
                      </p>

                      <h6>Target audience</h6>
                      <p>
                        I frequently inquire nonprofits,'Who their target
                        audiences are?" and they'll say, "Everybody." While I
                        can appreciate the reasoning behind that response, the
                        simple fact of the matter is that you cannot design for
                        "everyone." This is why there are so many different
                        kinds of computers, clothing, and cars. The website is
                        more likely to help your business achieve its objectives
                        if you identify and design for its top two audiences.
                      </p>

                      <h6>Site objective</h6>
                      <p>
                        Like the goals in your association's or organization's
                        strategic plan (and on the off chance that you don't
                        have one of those, you have greater worries than your
                        site!), The primary objectives of your website are
                        outlined in the objectives. For each target audience, I
                        like to ask my nonprofit clients to respond to the
                        following questions: When this audience visits your
                        website, what will they want to do? When this audience
                        visits your website, what actions do you want them to
                        take? During the design and content creation processes,
                        make sure to revisit your objectives to ensure that they
                        are met.
                      </p>
                      <h6>Responsive website</h6>
                      <p>
                        A responsive website's design automatically adjusts to
                        the screen size it is being viewed on when it is
                        responsively designed. Unfortunately, adding
                        responsiveness to an existing website can be
                        challenging; as well as being generally more
                        cost-effective to do a complete redesign. The days of
                        having two distinct websites, one for desktop computers
                        and one for mobile devices, are over.
                      </p>

                      <h6>Fresh content</h6>
                      <p>
                        Imagine if museums remained static in their displays.
                        After your initial visit, why would you ever return? We
                        keep returning to museums due to the new exhibits and
                        programming—new things to see. When we know that the
                        content will change and that new content will be
                        available, we return to websites. Create a content plan
                        for your website that will keep visitors coming back.
                      </p>
                      <h6>Engaging content</h6>
                      <p>
                        It is being documented that only 20-28% of a web page's
                        text is read. As a result, websites now feature
                        multimedia, lots of photos, and shorter text blocks. The
                        great thing about non-textual content is that you only
                        need a decent smartphone to quickly create your own
                        photos and videos.
                      </p>
                      <h6>Features</h6>
                      <p>
                        Donation buttons, online forms, embedded video or
                        podcasts, online quizzes, social media buttons and
                        integration, and a wide variety of other gadgets and
                        widgets are examples of features that contribute to a
                        website's dynamic and engaging nature. For the sake of a
                        design that is more cohesive, it is essential to
                        anticipate as many of these as possible. instead of
                        finding out later that you really wanted social media
                        buttons but don't know where to put them without taking
                        away or compressing other parts.
                      </p>
                      <h6>Search engine optimaization(SEO)</h6>
                      <p>
                        A search engine is where 68% of Internet users begin
                        their online experience. As a result, you'll want to
                        ensure that your website is search engine optimized.
                        Even though there are businesses that specialize in SEO,
                        the majority of nonprofits cannot afford to use their
                        services. Fortunately, you can do a lot of SEO work
                        yourself or with help from your web developer.
                      </p>
                      <h6>Site maintenance</h6>
                      <p>
                        The process of keeping a website up to date, running
                        smoothly, and performing at its best is known as website
                        maintenance. Keeping your website up and running
                        includes things like making sure all of the links work,
                        updating the content on a regular basis, updating
                        plugins and themes, managing users, and fixing any
                        broken links. Additionally, it includes more general
                        housekeeping tasks like regularly backing up your
                        website and monitoring its performance.
                      </p>
                      <h6>Accessibility</h6>
                      <p>
                        It is essential to test your website's accessibility to
                        ensure that everyone can use it. This includes people
                        who use mobile devices, have disabilities, and have slow
                        internet connections.
                      </p>
                    </div>
                  </div>

                  {/* <div id="blog-comment">
                    <h4>Comments</h4>

                    <div className="spacer-half"></div>

                    <ol>
                      <li>
                        <div className="avatar">
                          <img src="./img/blog/avatar-1.jpg" alt="blogimg" />
                        </div>
                        <div className="comment-info">
                          <span className="c_name">Jovan Eadie</span>
                          <span className="c_date id-color">
                            15 January 2020
                          </span>
                          <span className="c_reply">
                            <span>Reply</span>
                          </span>
                          <div className="clearfix"></div>
                        </div>

                        <div className="comment">
                          Sed ut perspiciatis unde omnis iste natus error sit
                          voluptatem accusantium doloremque laudantium, totam
                          rem aperiam, eaque ipsa quae ab illo inventore
                          veritatis et quasi architecto beatae vitae dicta sunt
                          explicabo.
                        </div>
                      </li>

                      <li>
                        <div className="avatar">
                          <img src="./img/blog/avatar-2.jpg" alt="blogimg" />
                        </div>
                        <div className="comment-info">
                          <span className="c_name">Ariana Haylock</span>
                          <span className="c_date id-color">
                            15 January 2020
                          </span>
                          <span className="c_reply">
                            <span>Reply</span>
                          </span>
                          <div className="clearfix"></div>
                        </div>

                        <div className="comment">
                          Sed ut perspiciatis unde omnis iste natus error sit
                          voluptatem accusantium doloremque laudantium, totam
                          rem aperiam, eaque ipsa quae ab illo inventore
                          veritatis et quasi architecto beatae vitae dicta sunt
                          explicabo.
                        </div>
                      </li>

                      <li>
                        <div className="avatar">
                          <img src="./img/blog/avatar-3.jpg" alt="blogimg" />
                        </div>
                        <div className="comment-info">
                          <span className="c_name">Reginald Safi</span>
                          <span className="c_date id-color">
                            15 January 2020
                          </span>
                          <span className="c_reply">
                            <span>Reply</span>
                          </span>
                          <div className="clearfix"></div>
                        </div>

                        <div className="comment">
                          Sed ut perspiciatis unde omnis iste natus error sit
                          voluptatem accusantium doloremque laudantium, totam
                          rem aperiam, eaque ipsa quae ab illo inventore
                          veritatis et quasi architecto beatae vitae dicta sunt
                          explicabo.
                        </div>
                      </li>
                    </ol>

                    <div className="spacer-single"></div>

                    <div id="comment-form-wrapper">
                      <h4>Leave a Comment</h4>
                      <div className="comment_form_holder">
                        <form
                          id="contact_form"
                          name="form1"
                          className="form-border"
                          method="post"
                          action="#"
                        >
                          <label>Name</label>
                          <input
                            type="text"
                            name="name"
                            id="name"
                            className="form-control"
                          />
                          <label>
                            Email <span className="req">*</span>
                          </label>
                          <input
                            type="text"
                            name="email"
                            id="email"
                            className="form-control"
                          />
                          <label>
                            Message <span className="req">*</span>
                          </label>
                          <textarea
                            cols="10"
                            rows="10"
                            name="message"
                            id="message"
                            className="form-control"
                          ></textarea>
                          <p id="btnsubmit">
                            <input
                              type="submit"
                              id="send"
                              value="Send"
                              className="btn btn-main"
                            />
                          </p>
                        </form>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* lightbox */}
      {lighbx2 && (
        <div className="LightboxGal">
          <div className="closeGal">
            <button
              className="button-close"
              onClick={handleBtnClickclose2}
            ></button>
          </div>
          <div className="v-center w-100">
            <div className="mainLightbox container">
              <div className="row">
                <div className="col-md-8 offset-md-2">
                  <div className="blog-read">
                    <img
                      alt="blogimg"
                      src="./img/blog/big3.jpg"
                      className="img-fullwidth rounded"
                    />

                    <div className="post-info">
                      <span className="post-date">February 14, 2023</span>
                      <span className="post-like"></span>
                      <span className="post-comment"></span>
                    </div>

                    <h2>The importance of Web Design</h2>

                    <div className="post-text">
                      <p>
                        One of your brand's most important online assets is your
                        website, so it's critical that you design it well.
                        Additionally, in order to convert your
                        bottom-of-the-funnel leads to conversions, you should
                        nurture them on your website. As a result, you can't
                        afford any website failures that might cause customers
                        to leave your site. Your website should be made with the
                        people you want to reach in mind, and it should make
                        using it enjoyable. A well-designed website has numerous
                        additional advantages for your business and audience.
                      </p>
                      <p>
                        When we say that web design can make or break your
                        business, we are not exaggerating. Don't think so? We'll
                        let the numbers speak for themselves. 75% of customers
                        say that a company's website design helps them quickly
                        assess its credibility.
                      </p>
                      <h6>Key Benefits of Having a Great Website Design</h6>
                      <ul>
                        <li>Gives a Good First Impression</li>
                        <li>Helps You Rank on Search Engines like Google</li>
                        <li>Makes You Look Credible and Easy to Talk To, </li>
                        <li>Helps to Get Leads and Convert Sales</li>
                        <li>Gives You a Brand Personality </li>
                      </ul>
                    </div>
                  </div>

                  {/* <div id="blog-comment">
                    <h4>Comments</h4>

                    <div className="spacer-half"></div>

                    <ol>
                      <li>
                        <div className="avatar">
                          <img src="./img/blog/avatar-1.jpg" alt="blogimg" />
                        </div>
                        <div className="comment-info">
                          <span className="c_name">Jovan Eadie</span>
                          <span className="c_date id-color">
                            15 January 2020
                          </span>
                          <span className="c_reply">
                            <span>Reply</span>
                          </span>
                          <div className="clearfix"></div>
                        </div>

                        <div className="comment">
                          Sed ut perspiciatis unde omnis iste natus error sit
                          voluptatem accusantium doloremque laudantium, totam
                          rem aperiam, eaque ipsa quae ab illo inventore
                          veritatis et quasi architecto beatae vitae dicta sunt
                          explicabo.
                        </div>
                      </li>

                      <li>
                        <div className="avatar">
                          <img src="./img/blog/avatar-2.jpg" alt="blogimg" />
                        </div>
                        <div className="comment-info">
                          <span className="c_name">Ariana Haylock</span>
                          <span className="c_date id-color">
                            15 January 2020
                          </span>
                          <span className="c_reply">
                            <span>Reply</span>
                          </span>
                          <div className="clearfix"></div>
                        </div>

                        <div className="comment">
                          Sed ut perspiciatis unde omnis iste natus error sit
                          voluptatem accusantium doloremque laudantium, totam
                          rem aperiam, eaque ipsa quae ab illo inventore
                          veritatis et quasi architecto beatae vitae dicta sunt
                          explicabo.
                        </div>
                      </li>

                      <li>
                        <div className="avatar">
                          <img src="./img/blog/avatar-3.jpg" alt="blogimg" />
                        </div>
                        <div className="comment-info">
                          <span className="c_name">Reginald Safi</span>
                          <span className="c_date id-color">
                            15 January 2020
                          </span>
                          <span className="c_reply">
                            <span>Reply</span>
                          </span>
                          <div className="clearfix"></div>
                        </div>

                        <div className="comment">
                          Sed ut perspiciatis unde omnis iste natus error sit
                          voluptatem accusantium doloremque laudantium, totam
                          rem aperiam, eaque ipsa quae ab illo inventore
                          veritatis et quasi architecto beatae vitae dicta sunt
                          explicabo.
                        </div>
                      </li>
                    </ol>

                    <div className="spacer-single"></div>

                    <div id="comment-form-wrapper">
                      <h4>Leave a Comment</h4>
                      <div className="comment_form_holder">
                        <form
                          id="contact_form"
                          name="form1"
                          className="form-border"
                          method="post"
                          action="#"
                        >
                          <label>Name</label>
                          <input
                            type="text"
                            name="name"
                            id="name"
                            className="form-control"
                          />
                          <label>
                            Email <span className="req">*</span>
                          </label>
                          <input
                            type="text"
                            name="email"
                            id="email"
                            className="form-control"
                          />
                          <label>
                            Message <span className="req">*</span>
                          </label>
                          <textarea
                            cols="10"
                            rows="10"
                            name="message"
                            id="message"
                            className="form-control"
                          ></textarea>
                          <p id="btnsubmit">
                            <input
                              type="submit"
                              id="send"
                              value="Send"
                              className="btn btn-main"
                            />
                          </p>
                        </form>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Blog;
